import React from 'react';
import { FilesComponent } from 'components';
import { fileEnums, Images, PermissionList } from 'utils';

export const ApptFiles = ({ item }) => {
    return (
        <div style={{ marginTop: 8 }}>
            <FilesComponent
                uploadBtnIcon={Images.addHours}
                uploadBtnText={'Add Document'}
                noSearch={true}
                currentId={item?.id}
                onResource={fileEnums.APPT}
                permissions={[PermissionList.APPT_FILE_MANAGE?.code]}
                height={'medium'}
            />
        </div>
    );
};
